import React from "react";
import { useLocation } from "react-router-dom";
import AllProject from "../Components/AllProject";

const Portfolio = () => {
  const { pathname } = useLocation();
  console.log(pathname);

  return (
    <div id="portfolio" className=" mt-16 lg:mt-0 ml-[-50px] lg:ml-0 md:ml-0">
      <pre className="text-center lg:py-3 text-secondary tracking-widest lg:text-4xl">
        Proj<span className="text-white">ects</span>
      </pre>

      <div className="w-11/12 mt-8 mx-auto">
        <AllProject />
      </div>
    </div>
  );
};

export default Portfolio;
